import { palette } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { Platform, StyleProp, View, ViewProps, ViewStyle } from 'react-native';

const shadow = ({
  color,
  opacity,
  radius,
  offsetWidth,
  offsetHeight,
  elevation,
}: any): StyleProp<ViewStyle> =>
  Platform.select({
    ios: {
      shadowColor: color,
      shadowOpacity: opacity,
      shadowRadius: radius,
      shadowOffset: {
        width: offsetWidth,
        height: offsetHeight,
      },
      borderColor: palette.white,
    },
    android: {
      elevation,
      borderColor: palette.white,
    },
    web: {
      boxShadow: `${offsetWidth}px ${offsetHeight}px ${radius}px ${color}`,
      backgroundColor: '#0000',
      borderRadius: '10px',
      borderColor: palette.white,
    },
  }) as any;

interface Props extends ViewProps {
  elevation?: number;
  color?: string;
  opacity?: number;
  radius?: number;
  offsetWidth?: number;
  offsetHeight?: number;
}

const Shadow: FC<Props> = ({
  style,
  elevation = 3,
  color = 'rgba(2,0,0,0.3)',
  opacity = 0.15,
  radius = 4,
  offsetWidth = 1,
  offsetHeight = 3,
  ...props
}) => {
  const shadowStyle = shadow({
    elevation,
    color,
    opacity,
    radius,
    offsetWidth,
    offsetHeight,
  });

  return (
    <View {...props} style={[shadowStyle, style]}>
      {props.children}
    </View>
  );
};

export default Shadow;
